module.exports = __webpack_public_path__ + "static/media/SplunkEnterpriseDataAdmin.b7305d8d.png";